/**
 * Extrage un mesaj lizibil din erorile aruncate de React Admin / API Platform.
 *
 * API Platform returneaza erori in format JSON-LD:
 * { "@type": "Error", "detail": "...", "violations": [...] }
 *
 * React Admin parseaza raspunsul si il pune in err.body sau err.message.
 */
export const getApiErrorMessage = (err) => {
    // Violations (erori de validare Symfony) - cel mai detaliat
    if (err?.body?.violations?.length) {
        return err.body.violations
            .map((v) => `${v.propertyPath ? v.propertyPath + ': ' : ''}${v.message}`)
            .join(', ');
    }

    // Detail din raspunsul API Platform
    if (err?.body?.detail) return translateApiError(err.body.detail);
    if (err?.body?.message) return err.body.message;

    // Fallback la err.message standard
    if (err?.message) return translateApiError(err.message);

    return 'A apărut o eroare neașteptată';
};

/**
 * Traduce mesajele tehnice frecvente din API în mesaje lizibile pentru utilizator.
 */
const translateApiError = (message) => {
    if (!message) return 'Eroare necunoscută';

    if (message.includes('Duplicate entry') && message.includes('email')) {
        return 'Adresa de email este deja folosită de un alt colaborator.';
    }
    if (message.includes('Duplicate entry')) {
        return 'Înregistrarea există deja (valoare duplicată).';
    }
    if (message.includes('UniqueConstraintViolation')) {
        return 'Valoare duplicată — această înregistrare există deja.';
    }
    if (message.includes('poti asocia/elimina doar propria echipa')) {
        return 'Poți asocia/elimina doar propria echipă pe un eveniment.';
    }
    if (message.includes('Nu ai dreptul')) {
        return message;
    }
    if (message.includes('Not Found') || message.includes('404')) {
        return 'Înregistrarea nu a fost găsită.';
    }
    if (message.includes('Access Denied') || message.includes('403')) {
        return 'Nu ai dreptul să efectuezi această acțiune.';
    }
    if (message.includes('Internal Server Error') || message.includes('500')) {
        return 'Eroare internă de server. Încearcă din nou sau contactează administratorul.';
    }

    return message;
};
